
import { PropType, defineComponent } from 'vue'

import DropDownComponent from './../form/DropDownComponent.vue'

export interface PlanAffiliationFormState {
  planType: string
  clientId: string
  configuredClient: object | null
  selectedClient: { title: string; value: string; plans?: unknown[] }
  clientOptions: unknown[]
}

export default defineComponent({
  name: 'plan-affiliations-form',
  components: {
    DropDownComponent
  },
  props: {
    planAffiliation: {
      type: Object as PropType<PlanAffiliationFormState>,
      required: true
    }
  }
})
